import { render, staticRenderFns } from "./FindPeople.vue?vue&type=template&id=9245f06a&scoped=true"
import script from "./FindPeople.vue?vue&type=script&lang=js"
export * from "./FindPeople.vue?vue&type=script&lang=js"
import style0 from "./FindPeople.vue?vue&type=style&index=0&id=9245f06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9245f06a",
  null
  
)

export default component.exports